'use client';
import React, { FC } from 'react';
import { useSearchParams } from 'next/navigation';
import {
  CLICKED_ITEM_TYPES,
  CTA_NAMES,
  PAGE_LOCATIONS,
  trackItemClickedEvent,
} from '@/utils/rudderstack';
import { useA11yState } from '@/hooks/useA11yState';

interface UsablenetAccessibilityLinkProps {
  enableAccessibilityLabel: string;
  disableAccessibilityLabel: string;
}

const UsablenetAccessibilityLink: FC<UsablenetAccessibilityLinkProps> = ({
  enableAccessibilityLabel,
  disableAccessibilityLabel,
}) => {
  const searchParams = useSearchParams();
  const urlA11yEnabled = searchParams?.get('UsableNetAssistive') === 'true';
  const { a11yEnabled, toggleA11y } = useA11yState(urlA11yEnabled);
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      className="UsableNetAssistive font-bold underline"
      onClick={(e) => {
        e.preventDefault();
        toggleA11y();
        trackItemClickedEvent({
          type: CLICKED_ITEM_TYPES.LINK,
          cta: a11yEnabled
            ? CTA_NAMES.EXIT_ACCESSIBILITY
            : CTA_NAMES.ENABLE_ACCESSIBILITY,
          pageLocation: PAGE_LOCATIONS.SITE_BANNER,
          url: window.location.href,
        });
        (window as any)?.enableUsableNetAssistive();
      }}
      href="#"
      data-testid="usablenet-accessibility-link"
    >
      {a11yEnabled ? disableAccessibilityLabel : enableAccessibilityLabel}
    </a>
  );
};

export default UsablenetAccessibilityLink;
